import axios from "axios";

export default {
  namespaced: true,
  state: {
    teams: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    teamsMessage: ''
  },
  mutations: {
    RECEIVED_TEAMS(state, payload) {
      state.teams = payload;
      state.isReceiving = false;
    },
    RECEIVING_TEAMS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TEAM(state, payload) {
      state = Object.assign(state, {
        teams: [...state.teams, payload],
        isReceiving: false,
      })
    },
    RECEIVING_TEAM(state) {
      state.isReceiving = true;
    },
    UPDATED_TEAM(state, payload) {
      let index = state.teams.findIndex(team => team._id === payload._id);
      state = Object.assign(state, {
        teams: state.teams.map((team, i) => {
          if (i === index) {
            return Object.assign({}, team, payload);
          }
          return team;
        }),
        isUpdating: false,
        teamsMessage: 'Teams has been updating!',
      })
    },
    UPDATING_TEAM(state) {
      state.isUpdating = true;
    },
    DELETED_TEAM(state, payload) {
      let indexToDelete = state.teams.findIndex(team => team._id === payload._id);
      let teams = [...state.teams];
      teams.splice(indexToDelete, 1);
      state = Object.assign(state, {
        teams: [...teams],
        isDeleting: false,
        idToDelete: null,
        teamsMessage: 'Team has been Deleted!',
      });
    },
    DELETING_TEAM(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteTeamRequest({dispatch}, payload) {
      dispatch("deletingTeam", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/team/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteTeam", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteTeamMemberRequest({dispatch}, payload) {
      try{
        dispatch("deletingTeam", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/teammember/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteTeam", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getTeamsRequest({dispatch}) {
      dispatch("receivingTeams");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/teams';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveTeams", res.data);
      })
    },
    async insertTeamRequest({dispatch}, payload) {
      dispatch("receivingTeam");
      let  token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/team';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveTeam", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertTeamMemberRequest({dispatch}, payload) {
      try{
        dispatch("receivingTeam");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/teammember/' + payload.teamid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateTeamRequest({dispatch}, payload) {
      dispatch("updatingTeam");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/team/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateTeam", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateTeamMemberRequest({dispatch}, payload) {
      try{
        dispatch("receivingTeam");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/teammember/' + payload.teammemberid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveTeam", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveTeams({commit}, payload) {
      commit("RECEIVED_TEAMS", payload)
    },
    receivingTeams({commit}) {
      commit("RECEIVING_TEAMS")
    },
    receiveTeam({commit}, payload) {
      commit("RECEIVED_TEAM", payload)
    },
    receivingTeam({commit}) {
      commit("RECEIVING_TEAM")
    },
    updateTeam({commit}, payload) {
      commit("UPDATED_TEAM", payload)
    },
    updatingTeam({commit}) {
      commit("UPDATING_TEAM")
    },
    deleteTeam({commit}, payload) {
      commit("DELETED_TEAM", payload)
    },
    deletingTeam({commit}, payload) {
      commit("DELETING_TEAM", payload)
    }
  },
};
